import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconLockOutline = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 18" size={size} {...props}>
        <StyledStrokedGroup color={color}>
            <StyledPath
                color="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M.813 7.313h12.374v10.125H.813V7.313z"
            />
            <StyledPath
                color="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.063 7.313V4.5a3.937 3.937 0 117.874 0v2.813M7 11.25v2.25"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
